import { makeStyles } from 'tss-react/mui'

// Styles for when hasExternalBaseURL is TRUE
const stylesWithExternalBaseURL = makeStyles()(theme => ({
  container: {
    display: 'block',
    gap: theme.spacing(0),
  },
  formWidth: { width: '100%' },
  activityLogWidth: { width: '30%' },
  hideActivityLog: {
    display: 'none',
  },
}))

// Styles for when hasExternalBaseURL is FALSE
const stylesWithoutExternalBaseURL = makeStyles()(theme => ({
  container: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  formWidth: { width: '70%' },
  activityLogWidth: { width: '30%' },
  hideActivityLog: {
    display: 'block',
  },
}))

// Export a function that returns the correct styles
export const useStyles = (hasExternalBaseURL: boolean) => {
  return hasExternalBaseURL
    ? stylesWithExternalBaseURL()
    : stylesWithoutExternalBaseURL()
}
